<template>
  <section class="printers-page">
    <div class="top-bar">
      <div class="top-bar--left">
        <b-button @click="tabIndex=0" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 0 }">{{$t('printers.navbar.printers')}}
        </b-button>
        <b-button @click="tabIndex=1" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 1 }">{{$t('printers.navbar.liveViewWall')}}
        </b-button>
      </div>
      <div class="top-bar--right">
        <b-form-input v-model="searchText" @keydown.enter.native="handleChangeSearch" :placeholder="$t('printers.navbar.search')" class="inp inp--combo"></b-form-input>
        <b-button variant="-combo btn--ternary btn--outline" @click="handleChangeSearch"><i class="icon icon--search"></i></b-button>
        <b-button variant="-primary" @click="handleOpenAddPrinter">
          {{$t('printers.navbar.addPrinter')}}
        </b-button>

        <b-dropdown variant="-ternary no--arr btn--dots btn--outline" text="⋮" right>
          <b-dropdown-item-button v-if="printersListMode!=='active'" @click="handleActivePrinters">{{$t('printers.navbar.activePrinters')}}</b-dropdown-item-button>
          <!--<b-dropdown-item-button @click="handleActivePrintersByHosts">{{$t('printers.navbar.activePrintersByHost')}}
          </b-dropdown-item-button>-->
          <b-dropdown-item-button v-if="printersListMode!=='inactive'" @click="handleInactivePrinters">{{$t('printers.navbar.inactivePrinters')}}</b-dropdown-item-button>
          <!--<b-dropdown-item-button @click="handleOpenWorkgroupAccess">{{$t('printers.navbar.addWorkgroupPrinters')}}
          </b-dropdown-item-button>-->
        </b-dropdown>

      </div>
    </div>

    <b-tabs v-model="tabIndex" style="min-height: 100px;">

      <b-tab class="files-page__projects-tab">
        <printers-tab :mode="printersListMode" :search="search"></printers-tab>
      </b-tab>

      <b-tab>
        <div v-if="tabIndex === 1">
          <live-view-wall></live-view-wall>
        </div>
      </b-tab>

    </b-tabs>

    <b-modal v-model="openAddPrinter" size="lg" hide-footer>
      <add-new-imprinta-printer @close="openAddPrinter = false"></add-new-imprinta-printer>
    </b-modal>

    <b-modal v-model="openWorkgroupAccess" title="WORKGROUP ACCESS" size="lg">
      <workgroup-access ref="workgroupAccessModal"></workgroup-access>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('buttons.cancel')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-secondary" @click="handleAddWorkgroupPrinters(ok)">
            {{$t('printers.buttons.connectToWorkgroup')}}
          </b-button>
        </div>
      </template>
    </b-modal>
  </section>
</template>

<script>
  import {mapGetters} from "vuex";

  import PrintersTab from "../components/printers/PrintersTab";
  import LiveViewWall from "../components/printers/LiveViewWall";
  import WorkgroupAccess from "../components/printers/modal/WorkgroupAccess";
  import AddNewImprintaPrinter from "../components/printers/modal/AddNewImprintaPrinter";

  export default {
    name: "Files",
    components: {
      AddNewImprintaPrinter,
      WorkgroupAccess,
      PrintersTab,
      LiveViewWall
    },
    data() {
      return {
        tabIndex: 0,
        printersListMode: 'active',
        openAddPrinter: false,
        openWorkgroupAccess: false,
        searchText: '',
        search: ''
      }
    },

    computed: {
      ...mapGetters(['getActivePrinters', 'isPrintersLoaded', 'getDisconnectedPrinters'])
    },

    mounted(){
      if (this.$route.params.open == 'add-printer') {
        //console.log(this.$route.query)
        this.openAddPrinter = true;
      }
    },
    methods: {
      handleInactivePrinters() {
        this.printersListMode = 'inactive';
      },
      handleActivePrinters() {
        this.printersListMode = 'active';
      },
      handleActivePrintersByHosts() {
        this.printersListMode = 'hosts';
      },
      handleOpenAddPrinter() {
        this.openAddPrinter = true;
      },
      handleOpenWorkgroupAccess() {
        this.openWorkgroupAccess = true;
      },
      handleAddWorkgroupPrinters(ok) {
        ok();
        this.$refs['workgroupAccessModal'].handleEnterAccessCode();
      },
      handleChangeSearch() {
        this.search = this.searchText;
      }
    }
  }
</script>

<style lang="scss">
  @import ".././scss/theme";

  .printers-page {
    .top-bar--left {
      .btn {
        margin: 0;
      }
    }
  }

  .only-printers {
    margin: 36px 0;
    padding: 0;
    border: 0;
    background: none;

    .printers-table__item {
      background: white;
      border-radius: $s-border-radius $s-border-radius 0 0;
      margin: auto 0 0 0;
      position: relative;
      transition: all .1s;
      box-shadow: -4px 4px 20px 0 rgba(0, 0, 0, 0.10);

      &.closed {
        transition: .1s;
        border-radius: $s-border-radius;
        box-shadow: -4px 0px 12px 0 rgba(0, 0, 0, 0.05);
      }

      &.active {
        z-index: 35;
      }

      .top-bar {
        z-index: 15;
        height: 56px;
        padding: 0 12px 0 16px;
        display: flex;


        .badge.status {
          margin-bottom: 1px;
        }

        h4 {
          margin: 0;
        }
      }

      &__temperature {
       min-width: 16vw;
        .printer-temperatures {
          span {
            display: inline-block;
            font-weight: 600;
            font-size: 14px;
            line-height: 1;
            margin: 0 18px;
            &:before {
              content: attr(data-content);
              margin: 4px 0 2px;
              display: block;
              color: $c-text-gray;
              opacity: .8;
              font-size: 12px;
              font-weight: 400;
            }
          }
        }
      }

      &__filaments {
        min-width: 16vw;
      }


      &__queue {
        height: 32px;
        line-height: 32px;
        position: relative;
        margin: auto;
        display: block;
        cursor: pointer;
        padding: 0 16px;
        background: white;
        z-index: 1;
        transition: .2s ease;

        &.collapsed {
          background: transparent;
          color: $c-text-gray;
        }

        &:hover {
          transition: .3s ease;
          background: #ffffff5a;
          color: black;
        }

        p {
          text-decoration: underline;

          span.separator {
            letter-spacing: 12px;
          }
        }
      }
      &.expanded {
        .top-bar {
          @media (max-width: 1300px) {
            flex-wrap: wrap;

            height: unset;
            min-height: 56px;
            &--left {
              width: 50%;
              padding: 14px 0;
            }
            &--mid {
              padding: 4px 0 8px;
              order: 3;
            }
            &--right {
              justify-content: flex-end;
              width: 50%;
            }

            .badge.status {
              top: 41px;
              &:after {
                top: -22px;
                right: -1px;
                transform: scaleY(1.735);
              }
            }
            .printers-table__item__filaments {
              min-width: unset;
            }
          }
        }
      }
    }

    table.table {
      position: relative;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.03);
      margin: auto;
      border-radius: 0 0 $s-border-radius $s-border-radius;
    }
  }

  .printers-table {
    .tog {
      margin-top: 12px;

      h3 {
        margin: 0;
      }

      .top-bar {
        padding: 0 24px;

        &--left {
          svg {
            margin: -1px 8px 0 10px;
            width: 14px;
            fill: white;
            height: auto;
          }
        }
      }
    }

    &__item {
      margin: 8px 0;

      &__progress {
        span:not(:first-child) {
          margin-left: 18px;
        }
      }

      &__tray {
        display: flex;

        span {
          padding-right: 10px;
        }
      }


      .top-bar {
        &--left {
          min-width: 480px;
        }

        padding: 4px 12px;
      }

      h4 {
        font-size: 18px;
        margin: 4px 0 0;

        span.model {
          color: lighten($c-black, 70%);
        }
      }

      .table {

        .action1 {
          padding-right: 0;
          margin-right: 12px;

          .btn-group {
            vertical-align: inherit;
          }

        }
      }
    }
  }
</style>
